import { render, staticRenderFns } from "./PwaInstallBanner.vue?vue&type=template&id=0353d29a&scoped=true"
import script from "./PwaInstallBanner.vue?vue&type=script&lang=js"
export * from "./PwaInstallBanner.vue?vue&type=script&lang=js"
import style0 from "./PwaInstallBanner.vue?vue&type=style&index=0&id=0353d29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353d29a",
  null
  
)

export default component.exports